import ReactGA from "react-ga4";

const TRACKING_ID = "G-RWYS34VRNL"; // G-XXXXXXXXXX

export const initGA = () => {
  if (TRACKING_ID) {
    ReactGA.initialize(TRACKING_ID);
    console.log("GA4 Initialized");
  } else {
    console.log("GA4 ID missing: Analytics disabled.");
  }
};

export const logPageView = () => {
  if (TRACKING_ID) {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search });
  }
};

export const logEvent = (category, action, label) => {
  if (TRACKING_ID) {
    ReactGA.event({ category, action, label });
  }
};
